<template>
  <div class="training-player-style-component"
       :class="[
         playing ? 'is-playing' : '',
         `training-${styleType}-player-style`
         ]"
  >
    <template v-if="isAudioType">
      <div class="icon-container">
        <ym-loading v-if="loading"
                    type="fading-circle"
                    :size="15"
        />
        <ym-icon v-else
                  :name="audioIcon"
        />
      </div>
      <player-dot class="player-dot"
                  :duration="duration"
      />
      <span class="player-duration">{{ duration }}s</span>
    </template>
    <template v-if="type === 'voice'">
      <div class="icon-container">
        <ym-icon class="icon-voice icon-voice-1"
                  name="voice-1"
        />
        <ym-icon class="icon-voice icon-voice-2"
                  name="voice-2"
        />
        <ym-icon class="icon-voice icon-voice-3"
                  name="voice-3"
        />
      </div>
      <player-dot :duration="duration"
      />
      <span class="player-duration">{{ duration }}s</span>
    </template>
  </div>
</template>

<script>
  import { Loading } from '@ymba/ym-ui';
  import PlayerDot from '@/components/TrainingPlayer/PlayerDot';

  export default {
    name: 'PlayerStyle',
    components: {
      PlayerDot,
      'ym-loading': Loading,
    },
    props: {
      type: {
        type: String,
        default: 'work',
        validator(val) {
          return ['task', 'work', 'voice'].includes(val);
        },
      },
      playing: {
        type: Boolean,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      duration: {
        type: Number,
        required: true,
      },
    },
    computed: {
      audioIcon() {
        return this.playing ? 'pause-fill' : 'play-fill';
      },
      isAudioType() {
        return ['work', 'task'].includes(this.type);
      },
      styleType() {
        const styleTypeMap = {
          work: 'voice',
          task: 'audio',
          voice: 'voice',
        };
        return styleTypeMap[this.type];
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-player-style-component {
    line-height: 1;
    display: inline-flex;
    align-items: center;
    border-radius: @border-radius-extra-large;
    padding: @size-small @size-base;
  }

  @icon-size: @size-base;
  .icon-container {
    flex-shrink: 0;
    margin-right: @size-small;
    display: flex;
    align-items: center;
    justify-content: center;
    width: @icon-size;
    height: @icon-size;
    overflow: hidden;
  }

  .player-duration {
    flex-shrink: 0;
    font-size: @font-size-base;
    margin-left: @size-base;
  }

  .training-audio-player-style {
    background-color: @color-white;
    color: @training-primary-color;
    .player-duration {
      color: @color-text-base;
    }
  }

  @voice-icon-size: 30px;

  .training-voice-player-style {
    background-color: @training-primary-color;
    color: @color-white;
    &.is-playing {
      .icon-voice-1 {
        animation: voice1 1s step-start infinite;
      }

      .icon-voice-2 {
        animation: voice2 1s step-start infinite;
      }

      .icon-voice-3 {
        animation: voice3 1s step-start infinite;
      }
    }
    .icon-container {
      width: @voice-icon-size;
      height: @voice-icon-size;
      position: relative;
    }

    .icon-voice {
      font-size: @voice-icon-size;
      position: absolute;
      left: 0;
    }
  }

  @keyframes voice1 {
    0%, 100% {
      opacity: 1;
    }
    33.3333% {
      opacity: 0;
    }
    66.6666% {
      opacity: 0;
    }
  }

  @keyframes voice2 {
    0%, 100% {
      opacity: 0;
    }
    33.3333% {
      opacity: 0;
    }
    66.6666% {
      opacity: 1;
    }
  }

  @keyframes voice3 {
    0%, 100% {
      opacity: 0;
    }
    33.3333% {
      opacity: 1;
    }
    66.6666% {
      opacity: 0;
    }
  }
</style>
